$('button#prev')?.click((e) => {
  if(['upgrade-started'].includes(header_page)) {
    // DISABLED
  } else if(['upgrade-plan'].includes(header_page)) {
    window.location = `/pages/upgrade-started?cartId=${ btoa(cartData?.id) }`;
  } else if(['upgrade-cosmo-care'].includes(header_page)) {
    window.location = `/pages/upgrade-plan`;
  } else if(['upgrade-accessories'].includes(header_page)) {
    window.location = `/pages/upgrade-cosmo-care`;
  } else if(['upgrade-review'].includes(header_page)) {
    window.location = `/pages/upgrade-accessories`;
  } else {
    alert(`Previous Button clicked from ${header_page}`);
  }
});

$('button#next')?.click((e) => {
  if(['upgrade-started'].includes(header_page)) {
    upgradeStarted();
  } else if(['upgrade-plan'].includes(header_page)) {
    reChargeProcessCartwithoutupsell();
  } else if(['upgrade-cosmo-care'].includes(header_page)) {
    window.location = `/pages/upgrade-accessories`;
  } else if(['upgrade-accessories'].includes(header_page)) {
    window.location = `/pages/upgrade-review`;
  } else if(['upgrade-review'].includes(header_page)) {
    $('html, body').animate({
      scrollTop: $("#checkout").offset().top
    }, 2000);
  } else {
    alert(`Next Button clicked from ${header_page}`);
  }
});

function fetchCart() {
  return new Promise((resolve, reject) => {
    const cartId = localStorage.getItem('shopify-gql-cartid');
    if (cartId) {
      jQuery.ajax({
        url: `${ACTIVATIONAPI_BASEURL}/shopify/cart/fetch`,
        type: "POST",
        contentType: "application/json",
        dataType: "JSON",
        processData: false,
        data: JSON.stringify({
          cart_id: cartId
        }),
      }).done(function (response) {
        return resolve(response?.cart ?? null);
      }).fail(function (error) {
        // showErrorMessage(error, "Cart Retrieval Failed");
        return resolve(false);
      });
    } else {
      // notify('error', "Cart Retrieval Failed", "We encountered an issue while retrieving your data. Please try starting from the first step.")
      return resolve(false);
    }
  })
}

window.addEventListener('wheel', function (e) {
  if (e.ctrlKey) {
    e.preventDefault();
  }
}, { passive: false });